@use 'vars';

$ICON_WIDTH: 31px;
$ICON_HEIGHT: 12px;

.ask-iq-heading {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: vars.$gap-xsmall;

  &__text {
    font-size: vars.$font-size-small;
    font-weight: vars.$font-weight-medium;
    color: vars.$ai-primary;
  }

  &__icon {
    width: $ICON_WIDTH;
    height: $ICON_HEIGHT;
    flex-shrink: 0;
  }
}
